import React from "react";

var FavoriteIcon = function FavoriteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.596 10.425c.791-.819.354-2.246-.74-2.414l-6.647-1.022a.056.056 0 0 1-.041-.032L13.342.886a1.463 1.463 0 0 0-2.69.001L7.83 6.961a.052.052 0 0 1-.041.032L1.143 8.022c-1.094.169-1.53 1.596-.738 2.414l4.812 4.974a.061.061 0 0 1 .016.052l-1.075 6.674c-.21 1.301 1.077 2.292 2.177 1.677l5.645-3.154a.052.052 0 0 1 .051 0l5.648 3.148c1.101.614 2.386-.379 2.176-1.679l-1.082-6.673a.062.062 0 0 1 .016-.052z"
  }));
};

FavoriteIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
FavoriteIcon.defaultProps.solid = true;
export default FavoriteIcon;